import { render, staticRenderFns } from "./TradeIn.vue?vue&type=template&id=4e06fdc0&scoped=true&"
import script from "./TradeIn.vue?vue&type=script&lang=js&"
export * from "./TradeIn.vue?vue&type=script&lang=js&"
import style0 from "./TradeIn.vue?vue&type=style&index=0&id=4e06fdc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06fdc0",
  null
  
)

export default component.exports